export default __webpack_public_path__ + "static/media/empty-icon3.3466f1cc.png";